import React, { useMemo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Table, Form, Button, Dimmer, Loader } from 'semantic-ui-react';
import numeral from 'numeral';
import PaymentSourceDisplay from './PaymentSourceDisplay';
import IntlCurrencyInput from "react-intl-currency-input"
import styles from './PaymentSource.module.scss';


const PaymentSources = ({ sources, isEdit, onAmountChange, onRemoveSource, policies, actions }) => {
	const [loading, setLoading] = useState(false);
	const [shouldCalculateConFee, setShouldCalculateConFee] = useState(false);
	const [conFee, setConFee] = useState({ totalConFee: 0 });
	const totalAmount = useMemo(() => sources.reduce((acc, s) => acc + Object.values((s || {}).amounts).reduce((acc2, v) => acc2 + v, 0), 0), [sources]);
	const isCreditCard = useMemo(() => sources.some(source => (source.fiserv !== null && source.fiserv.fundingCategory || '').toLowerCase() === 'credit'), [sources]);
	const showConvFee = isCreditCard === true && shouldCalculateConFee === true
	//setConFee({ totalConFee: 0 })

	const calcConvFee = async () => {
		try {
			setLoading(true);
			
				sources.map((source) => {
					if (source.type !== 'credit') {
						source.type = 'credit'
					}
					return source; 
				});

				const result = await actions.calculateConvienceFee(policies, sources);  
				console.log(result);
				const { responseData } = result.response;
				
				if (responseData) {
					let conFee = {totalConFee: 0}
					responseData.forEach(({feeAmount, policyNumber}) => {
						conFee.totalConFee += Number(feeAmount)
						conFee = {...conFee, [policyNumber]: feeAmount}
					})
					setConFee(conFee)
					sources.forEach((source) => {
						if ((source.fiserv !== null && source.fiserv.fundingCategory || '').toLowerCase() === 'credit') {
							source.feeAmount = conFee;
						}
					});
				}

			setLoading(false);
		} catch (err){
			console.log(err)
			setLoading(false);
		}
	}

	const shouldCalcConvFee = async () => {
		try {
			setLoading(true);
			const calculateFeeResponse  = await actions.shouldCalculateConvienceFee(); //IF this is false then UI wont show ConvFee and dont cal below method, also this logic will come for creditcard and existing creditcard wallet
			console.log(calculateFeeResponse.response);
			const { shouldCalculateFee } = calculateFeeResponse.response;
			setShouldCalculateConFee(shouldCalculateFee);
			setLoading(false);
			if(shouldCalculateFee) {
				calcConvFee();
			}
		} catch (err) {
			console.log(err)
			setLoading(false);
		}
	}

	useEffect(() => {
		if (isCreditCard) {
			shouldCalcConvFee()
		}
	}, [actions, policies, sources]);

	return (
		<div className='required fields'>{showConvFee &&
			<div className="inline field">
				<label className={styles.requiredLbl}> </label><p className={styles.displayInline}><b> Using a credit card now includes a convenience fee charged by our 3rd party credit card processor. The fee will be included in your total payment. To avoid paying this fee we also accept ACH/eCheck payments from your bank account.</b></p>
				</div>
		}
		{loading && (
					<Dimmer active inverted>
						<Loader active size='massive'>
							Getting Payment Information...
						</Loader>
					</Dimmer>
				)}
		<Table>
			<Table.Header>
				<Table.Row>
					<Table.HeaderCell> Method</Table.HeaderCell>
					{isEdit && <Table.HeaderCell></Table.HeaderCell>}
					<Table.HeaderCell>Policy/Account Number(s)</Table.HeaderCell>
					<Table.HeaderCell textAlign='right'>Amount(s)</Table.HeaderCell>
				
				</Table.Row>
			</Table.Header>
			<Table.Body>
				{sources.map((source, i) => {
					const amountNames = Object.keys(source.amounts);
					return (
						<React.Fragment key={i}>
							{amountNames.map((amountName, key) => {
								return (
									<React.Fragment key={key}>
									<Table.Row key={key}>
										{key === 0 && (
											<Table.Cell rowSpan={amountNames.length * 2}>
												<PaymentSourceDisplay source={source} includeAmount={false} />
											</Table.Cell>
										)}
										{isEdit && key === 0 && (
											<Table.Cell rowSpan={amountNames.length * 2}>
												<Button onClick={() => onRemoveSource(source)}>Remove</Button>
											</Table.Cell>
										)}
										<Table.Cell>{amountName}</Table.Cell>
										{isEdit && (
											<Table.Cell textAlign='right'>
												<Form>
													<Form.Field key={i} control={IntlCurrencyInput} name='amount' style={{ textAlign: 'right' }} value={source.amounts[amountName]} onChange={(e, value) => onAmountChange(e, source, value, amountName)} prefix='$ ' />
												</Form>
											</Table.Cell>
										)}
										{!isEdit && <Table.Cell textAlign='right'>{numeral(source.amounts[amountName]).format('$ 0,0.00')}</Table.Cell>}
									</Table.Row>
									<Table.Row>
											{showConvFee && <Table.Cell textAlign='right'>Convenience Fee <label className={styles.requiredLbl}> </label></Table.Cell>}
											{showConvFee && <Table.Cell textAlign='right'>{numeral(conFee[amountName]).format('$ 0,0.00')}</Table.Cell>}
									</Table.Row>
									</React.Fragment>
								);
							})}
						</React.Fragment>
					);
				})}
			</Table.Body>
			<Table.Footer>
				
				<Table.Row>
					{isEdit && <Table.HeaderCell></Table.HeaderCell>}
					<Table.HeaderCell></Table.HeaderCell>
					<Table.HeaderCell textAlign='right'>Total</Table.HeaderCell>
						<Table.HeaderCell textAlign='right'>{numeral(Number(totalAmount) + Number(conFee.totalConFee)).format('$ 0,0.00')}</Table.HeaderCell>



				</Table.Row>
			</Table.Footer>
			</Table>
		</div>
	);
};

PaymentSources.propTypes = {
	sources: PropTypes.array.isRequired,
	isEdit: PropTypes.bool,
	onAmountChange: PropTypes.func,
	onRemoveSource: PropTypes.func
};

export default PaymentSources;
